import { axisAnimationAxis, axisAnimationFinal } from '../axis/cartesian-axis.animation';
export default {
  "initial.axisRefVisuals.axisRefVisualsCartesian": axisAnimationAxis,
  "update.axisRefVisuals.axisRefVisualsCartesian": axisAnimationFinal
};